import Vue from 'vue'
import Vuex from 'vuex'
import User from "./modulos/user"
import Venda from "./modulos/venda-store"
import Cliente from "./modulos/cliente-store"
import Areceber from "./modulos/areceber-store"
import Apagar from "./modulos/apagar-store"
import CompraGado from "./modulos/compra-gado-store"
import Cfop from "./modulos/cfop-store"
import GrupoAcesso from "./modulos/grupo-acesso-store"
import Controles from "./modulos/controle-store"
import Menu from "./modulos/menu-store"
import Vendedor from "./modulos/vendedor-store"
import OrdemAbate from "./modulos/ordem-abate-store"
import AbateResumo from "./modulos/abate-resumo-store"
import NotaFiscal from "./modulos/nota-fiscal"
import VendaPedido from "./modulos/venda-pedido-store"
import OrdemExpedicao from "./modulos/ordem-expedicao-store"
import OrdemEntrega from "./modulos/ordem-entrega-store"
import PedidoVendaWeb from "./modulos/pedido-venda-web-store"
import Compra from "./modulos/compra-store"
import Recebido from "./modulos/recebido-store"
import Mensagem from "./modulos/mensagem-store"
import Produto from "./modulos/produto-store"
import Bens from "./modulos/bens-store"
import Almoxarife from "./modulos/almoxarife-store"
import AlmoxarifeEstoque from "./modulos/almoxarife-estoque-store"
import TributacaoIcms from "./modulos/tributacao-icms-store"
import AjusteEstoque from "./modulos/ajuste-estoque-store"
import GrupoApagar from "./modulos/grupo-apagar-store"
import GrupoAreceber from "./modulos/grupo-areceber-store"
import GrupoProduto from "./modulos/grupo-produto-store"
import SubgrupoProduto from "./modulos/subgrupo-produto-store"
import TipoBeneficiamento from "./modulos/tipo-beneficiamento-store"
import TipoProduto from "./modulos/tipo-produto-store"
import Transportadora from "./modulos/transportadora-store"
import Tema from "./modulos/tema-store"
import Departamento from "./modulos/departamento-store"
import CentroCusto from "./modulos/centrocusto-store"
import CentroEstoque from "./modulos/centro-estoque-store"
import Veiculo from "./modulos/veiculo-store"
import Nfe from "./modulos/nfe-store"
import Pago from "./modulos/pago-store"
import Funcionario from "./modulos/funcionario-store"
import Historico from "./modulos/historico-store"
import BoletoRemessa from "./modulos/boleto-remessa-store"
import BoletoRetorno from "./modulos/boleto-retorno-store"
import Banco from "./modulos/banco-store"
import Usuario from "./modulos/usuario-store"
import RetiradaServico from "./modulos/retirada-servico-estore"
import PedidoProducao from "./modulos/pedido-producao-store"
import TipoMovimentacao from "./modulos/tipo-movimentacao-store"
import EstoqueDiversos from "./modulos/estoque-diversos-store"
import ConciliacaoBancaria from "./modulos/conciliacao-bancaria-store"
import ConferenciaFinanceira from "./modulos/conferencia-financeira-store"
import ProducaoFormula from "./modulos/producao-formula-store"
import ProducaoFormulaProcesso from "./modulos/producao-formula-processo-store"
import ProducaoFormulaRastreabilidade from "./modulos/producao-formula-rastreabilidade-store"
import Auditoria from "./modulos/auditoria-store"
import Devolucao from "./modulos/devolucao-store"



Vue.use(Vuex)

// ISLO Tenho que passar Registrar o dadosSessao para dentro da minha Store, e é claro para dentro do objeto state
export default new Vuex.Store({
  modules: {
    user: User,
    cliente: Cliente,
    venda: Venda,
    areceber: Areceber,
    apagar: Apagar,
    compraGado: CompraGado,
    cfop: Cfop,
    grupoAcesso: GrupoAcesso,
    controle: Controles,
    menu: Menu,
    vendedor: Vendedor,
    ordemAbate: OrdemAbate,
    abateResumo: AbateResumo,
    notafiscal: NotaFiscal,
    vendaPedido: VendaPedido,
    ordemExpedicao: OrdemExpedicao,
    ordemEntrega: OrdemEntrega,
    pedidoVendaWeb: PedidoVendaWeb,
    recebido: Recebido,
    compra: Compra,
    mensagem: Mensagem,
    produto: Produto,
    bens: Bens,
    almoxarife: Almoxarife,
    almoxarifeEstoque: AlmoxarifeEstoque,
    tributacaoIcms: TributacaoIcms,
    ajusteEstoque: AjusteEstoque,
    grupoApagar: GrupoApagar,
    grupoAreceber: GrupoAreceber,
    grupoProduto: GrupoProduto,
    subgrupoProduto: SubgrupoProduto,
    tipoBeneficiamento: TipoBeneficiamento,
    tipoProduto: TipoProduto,
    transportadora: Transportadora,
    tema: Tema,
    departamento: Departamento,
    centrocusto: CentroCusto,
    centroEstoque: CentroEstoque,
    veiculo: Veiculo,
    nfe: Nfe,
    pago: Pago,
    funcionario: Funcionario,
    historico: Historico,
    boletoRemessa: BoletoRemessa,
    boletoRetorno: BoletoRetorno,
    banco: Banco,
    usuario: Usuario,
    retiradaServico: RetiradaServico,
    pedidoProducao: PedidoProducao,
    tipoMovimentacao: TipoMovimentacao,
    estoqueDiversos: EstoqueDiversos,
    conciliacaoBancaria: ConciliacaoBancaria,
    conferenciaFinanceira: ConferenciaFinanceira,
    producaoFormula: ProducaoFormula,
    producaoFormulaProcesso: ProducaoFormulaProcesso,
    producaoFormulaRastreabilidade: ProducaoFormulaRastreabilidade,
    auditoria: Auditoria,
    devolucao: Devolucao
  }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js